<template>
  <div>
    <v-container fluid class="my-0 py-0">
      <v-card class="mt-3" :elevation="8">
        <ProduzioneLayout
          :commessa={}
          :filtroEM="'1'"
          :rotta_back="rotta_back"
          :work_order_sempre_aperto="false"
        />
      </v-card>
    </v-container>
  </div>
</template>
<script>
import ProduzioneLayout from "@/views/PRODUCTION/ProduzioneLayout/ProduzioneLayout.vue";

export default {
  name: "EMProduzioneLayoutAdapter",
  props: [],
  components: {
    ProduzioneLayout,
  },
  data() {
    return {
      // Variabili d'appoggio
      rotta_back: "/home/electrical",
      // Modal

      // Array
    };
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>